import { Box, IconButton, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router';
import BackIcon from '@mui/icons-material/KeyboardArrowLeft';
import { messageNavigationState } from '../../container/MessageContainerNavigationState';
import {
  Routes,
  METRICS_EXPAND_MESSAGING_VIEW,
  useAnalytics,
} from '@xolv-mybrightlink/common';
import { useCallback } from 'react';

type EmbeddedActionHeaderProps = {
  channelGuid: string;
  titleId: string;
};

const EmbeddedActionHeader = (props: EmbeddedActionHeaderProps) => {
  const { channelGuid, titleId } = props;
  const intl = useIntl();
  const navigate = useNavigate();
  const openMessaging = () => {
    navigate(Routes.messages.channel.conversation(channelGuid));
  };
  return (
    <Box
      sx={{
        height: 65,
        display: 'flex',
        alignItems: 'center',
        flexShrink: '0',
        borderBottom: 'solid 0.5px #d8dade',
        bgcolor: 'white',
      }}
    >
      <Typography sx={{ fontWeight: 500, pl: 10 }}>
        {intl.formatMessage({ id: titleId })}
      </Typography>
      <IconButton onClick={openMessaging} sx={{ mr: 5, ml: 'auto' }}>
        <CloseIcon sx={{ width: 32, height: 32, color: '#3b4559' }} />
      </IconButton>
    </Box>
  );
};

type StandaloneActionHeaderProps = {
  titleId: string;
  onClose?: () => void;
  expandRoute: string;
};

const StandaloneActionHeader = (props: StandaloneActionHeaderProps) => {
  const { titleId, onClose, expandRoute } = props;
  const intl = useIntl();
  const navigate = useNavigate();
  const analytics = useAnalytics();

  const expand = useCallback(() => {
    analytics.trackAction(METRICS_EXPAND_MESSAGING_VIEW);
    messageNavigationState.collapsedPath = location.pathname;
    navigate(expandRoute);
  }, [analytics, navigate, expandRoute]);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexShrink: '0',
        borderBottom: 'solid 0.5px #d8dade',
        bgcolor: 'white',
        px: 2,
      }}
    >
      <IconButton onClick={onClose}>
        <BackIcon sx={{ width: 32, height: 32 }} />
      </IconButton>
      <Typography sx={{ fontWeight: 500 }}>
        {intl.formatMessage({ id: titleId })}
      </Typography>
      <IconButton onClick={expand} sx={{ ml: 'auto' }}>
        <img src='/public/assets/icons/ic_expand_care_team.svg' alt='Expand' />
      </IconButton>
    </Box>
  );
};

type MessagingActionHeaderProps = {
  standalone?: boolean;
  titleId: string;
  channelGuid: string;
  onClose?: () => void;
  expandRoute: string;
};

export const MessagingActionHeader = (props: MessagingActionHeaderProps) => {
  const { standalone, channelGuid, titleId, onClose, expandRoute } = props;
  return standalone ? (
    <StandaloneActionHeader
      titleId={titleId}
      onClose={onClose}
      expandRoute={expandRoute}
    />
  ) : (
    <EmbeddedActionHeader channelGuid={channelGuid} titleId={titleId} />
  );
};
